import axios from "axios";

export const createJobViaAI = async (externalJobData) => {
  return axios.post("/wp-json/api/v2/generate_ai_screening_prompt", {
    externalJobData,
  });
};
